<template>
  <div v-if="!isMobile" class="container">
    <div class="table-container">
      <table v-if="loadingTable">
        <thead>
          <tr>
            <th v-for="(header, index) in headers" :key="index">{{ header.text }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-for="header in headers" :key="header.value">
              <div class="skeleton"></div>
            </td>
          </tr>
        </tbody>
      </table>

      <table v-else-if="!loadingTable && divisionTerm < 2" id="time__table">
        <thead>
          <tr>
            <th v-for="(header, index) in headers" :key="index" @click="sortTable(header)" :search="search">

              {{ header.text }}
              <span v-if="sortKey === header.value">
                <v-icon small color="white">{{ sortDirection === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down' }}</v-icon>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, row) in sortedItems" :key="row">
            <td v-for="header in headers" :key="header.value">
              {{ item[header.value] }}  
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div v-else>
    <div class="mb-table">
      <div class="value-group" v-for="(item, row) in sortedItems" :key="row">
        <!-- 날짜 표시 -->
        <div class="timetable-hd" v-show="$route.path !== '/watt'">
          <div>{{ item.date }}</div>
        </div>

        <!-- 동적 데이터 항목 -->
        <div class="value_flex" v-for="(header, index) in headers" :key="index"
        :class="{ 'highlight': index === 0 || index === 1 }">
          <div class="label">{{ header.text }}</div>
          <div class="value">{{ item[header.value] }}</div>
        </div>

        <div class="line-table"> </div>
      </div>

    </div>
  </div>
</template>


<script>

export default {
  props: {
    items: {
      type: Array,
    },
    headers:{
      type:Array
    },
    search: String,
    loadingTable: Boolean,
    divisionTerm: Number,
  },
  data(){
    return{
      sortKey: 'date',  // 현재 정렬하고 있는 열
      sortDirection: 'desc',  // 정렬 방향 ('asc' 또는 'desc')

      isMobile: window.innerWidth < 769
    }
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    filteredItems() {
      if (!this.search) return this.items;
      return this.items.filter(item =>
        Object.values(item).some(value =>
          String(value).toLowerCase().includes(this.search.toLowerCase())
        )
      );
    },
    sortedItems() {
      if (!this.sortKey) {
        return this.items;
      }
      return this.items.slice().sort((a, b) => {
        let result = 0;

        // 첫 번째 기준: 측정일 (sortKey가 'date'일 때)
        if (this.sortKey === 'date') {
          if (a.date < b.date) {
            result = -1;
          } else if (a.date > b.date) {
            result = 1;
          } else {
            // 측정일이 같을 때 측정시간으로 추가 정렬
            if (a.time < b.time) {
              result = -1;
            } else if (a.time > b.time) {
              result = 1;
            }
          }
        } else {
          // 다른 sortKey에 대한 기본 정렬
          if (a[this.sortKey] < b[this.sortKey]) {
            result = -1;
          } else if (a[this.sortKey] > b[this.sortKey]) {
            result = 1;
          }
        }

        // 정렬 방향에 따라 오름차순/내림차순 결정
        return this.sortDirection === 'asc' ? result : -result;
      });
    },
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 769;
    },
    sortTable(header) {
      if (this.sortKey === header.value) {
        // 같은 열을 클릭하면 방향을 변경
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        // 다른 열을 클릭하면 새로운 열로 정렬
        this.sortKey = header.value;
        this.sortDirection = 'desc'; // 새로운 열 선택 시 기본 정렬을 'desc'로s
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import '../../style/timetable_mb.scss';
.container{
  width:100%;
  margin:0;
  padding:0;
}
.table-container {
  height:70vh;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  overflow-y: auto;
  border-radius: 20px;
  border: 1px solid #ddd;
}

table {
  width: 100%;
  table-layout: fixed; 
  border-spacing: 0;
  border-collapse: collapse;
  text-align: center;
}

thead {
  position: sticky;
  top: 0;
  background-color: #005B96;
  color: white;
  z-index: 1;
}
thead th {
  padding: 10px;
}

tbody td {
  padding: 5px;
  border: 1px solid #ddd;
  background-color: white;
}


.skeleton {
  background-color: #f0f0f0;
  padding: 15px;
  width: 100%;
  border-radius: 20px;
  animation: skeleton-loading 1s linear infinite alternate;
}
@keyframes skeleton-loading {
  0% {
    background-color: #f0f0f0;
  }
  100% {
    background-color: #e0e0e0;
  }
}

@media only screen and (max-width: 768px) {
  .table-container {
    /* width: 95%; */
    overflow-x: auto;
    margin-left:-35px !important;
  }

  table {
    /* min-width: 500px;  */
  }
}
</style>